import { BaseDataModel } from "@domain/CRM/BaseDataModel";

/** A RIG-prefixed vehicle from the Equipment base (Momentum GPS position). Null
 *  coordinates mean the tracker has never reported. `coordinateUpdatedAt` is plumbed
 *  for future staleness UI (unused today). */
export class Truck extends BaseDataModel {
	name!: string;
	latitude!: number | null;
	longitude!: number | null;
	coordinateUpdatedAt?: Date | null;
}
